import { useRef, useState, useEffect, useContext } from 'react';
import "../css/Modal.css"
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import FetchUtil from "../utils/FetchUtil";
import { scrollToTop } from "../utils/helper.js";
import { ddStyles } from "../utils/CommonStyles.js";

let timezoneOptions = [];
let countryOptions = [];
let stateOptions = [];
let uomOptions = [];
let defCountryText = "Select Country";
let companyTypeOptions = [];
function CompanyModal({ key, t, company, setShow, refetch, add }) {
    const [states, setStates] = useState([]);
    //const [countries, setCountries] = useState([]);
    const [companyTypeSelected, setCompanyTypeSelected] = useState({ name: "companyTypeKey", label: (company.companyTypeDesc), value: company.companyTypeKey });
    const [companyGroups, setCompanyGroups] = useState([]);
    //const [timezones, setTimezones] = useState([]);
    const [error, setError] = useState("");
    const [formErrors, setFormErrors] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const userCtx = useContext(UserContext);
    const navigate = useNavigate();
    const [stateSelected, setStateSelected] = useState({ name: "stateKey", label: (company.stateName), value: (company.stateKey + "-" + company.stateCode) });
    const [countrySelected, setCountrySelected] = useState({ name: "countryCode", label: (company.countryName), value: company.countryCode });
    const [timezoneSelected, setTimezoneSelected] = useState({ name: "companyTimeZone", label: (company.companyTimeZone), value: company.companyTimeZone });
    const [countryLoaded, setCountryLoaded] = useState(false);
    const [stateLoaded, setStateLoaded] = useState(false);
    const [timezoneLoaded, setTimezoneLoaded] = useState(false);
    const [uomSelected, setUomSelected] = useState({ name: "unitOfMeasure", label: (company.unitOfMeasure), value: company.unitOfMeasure });
    const [uomLoaded, setUomLoaded] = useState(false);
    const [companyTypeLoaded, setCompanyTypeLoaded] = useState(false);
    const multiCompanyRef = useRef(null);
    const [multiCompany, setMultiCompany] = useState(company.multiCompany);
    const canTakeCorrectiveActionRef = useRef(null);
    const [isCanTakeCorrectiveAction, setIsCanTakeCorrectiveAction] = useState(company.canTakeCorrectiveAction);


    const submitText = t("page.submit");
    const closeText = t("page.close");

    const initialValues = {
        companyId: company.companyId,
        companyName: company.companyName,
        companyTypeKey: company.companyTypeKey,
        companyGroup: company.companyGroup,
        address1: company.address1,
        address2: company.address2,
        phone: company.phone,
        zipCode: company.zipCode,
        zipExt: company.zipExt,
        city: company.city,
        stateKey: company.stateKey,
        stateCode: company.stateCode,
        stateName: company.stateName,
        countryCode: company.countryCode,
        countryName: company.countryName,
        companyTimeZone: company.companyTimeZone,
        companyTypeAliasKey: company.companyTypeAliasKey,
        realCompanyName: company.realCompanyName,
        contactName: company.contactName,
        contactEmail: company.contactEmail,
        companyURL: company.companyURL,
        companyLanguage: company.companyLanguage,
        geocode: company.geocode,
        latitude: company.latitude,
        longitude: company.longitude,
        unitOfMeasure: company.unitOfMeasure,
        multiCompany: company.multiCompany,
        updatedById: userCtx.loggedInUserId,
        canTakeCorrectiveAction: company.canTakeCorrectiveAction,
    };
    const [formValues, setFormValues] = useState(initialValues);

    useEffect(() => {
        fetchCountries();
        fetchStates();
        fetchCompanyTypes();
        fetchCompanyGroups();
        fetchTimezones();
        fetchUOM();
        scrollToTop();
    }, []);

    function setCountryValues(countryObj) {
        let countryOptionValue = {};
        countryOptions = [];
        countryOptions.push({ label: "", value: "" });
        if (countryObj && countryObj.length > 0) {
            countryObj.map((country, index) => {
                countryOptionValue.label = country.countryName;
                countryOptionValue.value = country.countryCode;
                countryOptions.push(countryOptionValue);
                countryOptionValue = {};
            });
            setCountryLoaded(true);
        }

    }
    function setStateValues(stateObj, countryCode, defDataLoad) {
        let stateValue = {};
        stateOptions = [];
        stateOptions.push({ label: "", value: "0-" });
        if (stateObj && stateObj.length > 0) {
            stateObj.map((state, index) => {
                if (state.countryCode === countryCode) {
                    stateValue.label = state.name;
                    stateValue.value = state.stateKey + "-" + state.stateCode;
                    stateOptions.push(stateValue);
                    stateValue = {};
                }

            });
            setStateLoaded(true);
            if (!defDataLoad) {
                setStateSelected({ ...stateSelected, label: "", value: "0-" });
            }

        }
    }
    function setTimezoneValues(timezoneObj) {
        let timezoneValue = {};
        timezoneOptions = [];
        timezoneOptions.push({ label: "", value: "" });
        if (timezoneObj && timezoneObj.length > 0) {
            timezoneObj.map((timezone, index) => {
                timezoneValue.label = timezone.timezone;
                timezoneValue.value = timezone.timezone;
                timezoneOptions.push(timezoneValue);
                timezoneValue = {};

            });
            setTimezoneLoaded(true);
        }
    }

    function setUOMValues(uomObj) {
        let uomValue = {};
        uomOptions = [];
        if (uomObj && uomObj.length > 0) {
            uomObj.map((aUom, index) => {
                uomValue.label = aUom.uom;
                uomValue.value = aUom.uom;
                uomOptions.push(uomValue);
                uomValue = {};
            });
            setUomLoaded(true);
        }
    }

    function fetchStates() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: true, countryCode: (company.countryCode ? company.countryCode : "US") }),
        };
        try {
            FetchUtil.fetchAPI("MGetAllState", "/Service/StaticHelper/GetAllState", requestOptions, getStatesSuccess, getStatesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getStatesFail(redirect) {
        setError(t("error.getStateFailed"));
    }
    function getStatesSuccess(responseData) {
        let stateResponse;
        if (responseData) {
            stateResponse = responseData.getStateResponse;
            if (stateResponse && stateResponse.errorCode === "0") {
                setStateValues(stateResponse.states, formValues.countryCode, true);
                setStates([...states, ...stateResponse.states]);
            } else if (stateResponse) {
                setError(t("error.error") + " " + stateResponse.errorMessage);
            }
        }
    }

    function fetchCountries() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web" }),
        };
        try {
            FetchUtil.fetchAPI("MGetCountries", "/Service/StaticHelper/GetCountries", requestOptions, getCountriesSuccess, getCountriesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getCountriesFail(redirect) {
        setError(t("error.getCountryFailed"));
    }
    function getCountriesSuccess(responseData) {
        let countriesResponse;
        if (responseData) {
            countriesResponse = responseData.getCountriesResponse;
            if (countriesResponse && countriesResponse.errorCode === "0") {
                // setCountries([...countries, ...countriesResponse.countries]);
                setCountryValues(countriesResponse.countries);
            } else if (countriesResponse) {
                setError(t("error.error") + " " + countriesResponse.errorMessage);
            }
        }
    }
    function fetchCompanyTypes() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web" }),
        };
        try {
            FetchUtil.fetchAPI("MGetAllCompanyTypes", "/Service/StaticHelper/GetCompanyTypes", requestOptions, getCompanyTypesSuccess, getCompanyTypesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getCompanyTypesFail(redirect) {
        setError(t("error.getCompanyTypeFailed"));
    }
    function getCompanyTypesSuccess(responseData) {
        let companyTypesResponse;
        if (responseData) {
            companyTypesResponse = responseData.getCompanyTypesResponse;
            if (companyTypesResponse && companyTypesResponse.errorCode === "0") {
                setCompanyTypeValues(companyTypesResponse.companyTypes);
            } else if (companyTypesResponse) {
                setError(t("error.error") + " " + companyTypesResponse.errorMessage);
            }
        }
    }

    function setCompanyTypeValues(companyTypeObj) {
        let companyTypeValue = {};
        companyTypeOptions = [];
        companyTypeOptions.push({ label: "", value: 0 });
        if (companyTypeObj && companyTypeObj.length > 0) {
            companyTypeObj.map((aCompanyType, index) => {
                companyTypeValue.label = aCompanyType.description;
                companyTypeValue.value = aCompanyType.companyTypeKey;
                companyTypeOptions.push(companyTypeValue);
                companyTypeValue = {};


            });
            setCompanyTypeLoaded(true);
        }
    }

    function fetchCompanyGroups() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web" }),
        };
        try {
            FetchUtil.fetchAPI("MGetAllCompanyGroups", "/Service/StaticHelper/GetCompanyGroups", requestOptions, getCompanyGroupsSuccess, getCompanyGroupsFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getCompanyGroupsFail(redirect) {
        setError(t("error.getEntityFailed"));
    }
    function getCompanyGroupsSuccess(responseData) {
        let companyGroupsResponse;
        if (responseData) {
            companyGroupsResponse = responseData.getCompanyGroupsResponse;
            if (companyGroupsResponse && companyGroupsResponse.errorCode === "0") {
                setCompanyGroups([...companyGroups, ...companyGroupsResponse.companyGroups]);
            } else if (companyGroupsResponse) {
                setError(t("error.error") + " " + companyGroupsResponse.errorMessage);
            }
        }
    }

    function fetchTimezones() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("MGetTimeZone", "/Service/StaticHelper/GetTimeZones", requestOptions, getTimezonesSuccess, getTimezonesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getTimezonesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getTimezoneFailed"));
    }

    function getTimezonesSuccess(responseData) {
        let timezoneResponse;
        if (responseData) {
            timezoneResponse = responseData.getTimeZoneResponse;
            if (timezoneResponse && timezoneResponse.errorCode === "0") {
                //setTimezones([...timezones, ...timezoneResponse.timeZones]);
                setTimezoneValues(timezoneResponse.timeZones);
            } else if (timezoneResponse) {
                setError(t("error.error") + " " + timezoneResponse.errorMessage);
            }
        }
    }

    function fetchUOM() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("UnitOfMeasure", "/Service/StaticHelper/GetUnitOfMeasures", requestOptions, getUOMSuccess, getUOMFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getUOMFail(redirect) {
        setError(t("error.getUOMFailed"));
    }

    function getUOMSuccess(responseData) {
        let unitOfMeasuresResponse;
        if (responseData) {
            unitOfMeasuresResponse = responseData.getUnitOfMeasuresResponse;
            if (unitOfMeasuresResponse && unitOfMeasuresResponse.errorCode === "0") {
                setUOMValues(unitOfMeasuresResponse.uomList);
            } else if (unitOfMeasuresResponse) {
                setError(t("error.error") + " " + unitOfMeasuresResponse.errorMessage);
            }
        }
    }
    const valueHandler = (e) => {
        const { name, value } = e.target;
        if (typeof value === 'undefined') {
            value = "";
        }
        setFormValues({ ...formValues, [name]: value });
    }
    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        setIsCanTakeCorrectiveAction(event.target.checked);
        setFormValues({ ...formValues, [name]: event.target.checked });
    }

    const countryHandler = (selectedOption, action) => {
        let countryCode = selectedOption ? selectedOption.value : "";
        let countryName = selectedOption ? selectedOption.label : "";
        formValues.countryCode = countryCode;
        setCountrySelected({ ...countrySelected, label: (countryName), value: countryCode });
        setStateValues(states, countryCode, false);
    }
    const stateHandler = (selectedOption, action) => {
        let state = selectedOption ? selectedOption.value : "";
        let stateName = selectedOption ? selectedOption.label : "";
        setStateSelected({ ...stateSelected, label: (stateName), value: state });
        if (state) {
            let stateArr = state.split("-");
            formValues.stateKey = stateArr[0];
            formValues.stateCode = stateArr[1];
        }
    }
    const timezoneHandler = (selectedOption, action) => {
        let timezoneCode = selectedOption ? selectedOption.value : "";
        let timezoneName = selectedOption ? selectedOption.label : "";
        formValues.userTimeZone = timezoneCode;
        setTimezoneSelected({ ...timezoneSelected, label: (timezoneName), value: timezoneCode });
    }
    const uomHandler = (selectedOption, action) => {
        let uomCode = selectedOption ? selectedOption.value : "";
        let uomName = selectedOption ? selectedOption.label : "";
        formValues.unitOfMeasure = uomCode;
        setUomSelected({ ...uomSelected, label: (uomName), value: uomCode });
    }

    const companyTypeHandler = (selectedOption, action) => {
        let companyTypeKey = selectedOption ? selectedOption.value : 0;
        let companyTypeDesc = selectedOption ? selectedOption.label : "";
        formValues.companyTypeKey = companyTypeKey;
        setCompanyTypeSelected({ ...companyTypeSelected, label: companyTypeDesc, value: companyTypeKey });
    }

    const multiCompanyHandler = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        //const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        formValues.multiCompany = event.target.checked;
        setMultiCompany(event.target.checked);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmit(true);
        const formData = new FormData(event.currentTarget);
        for (let entry of formData.entries()) {
            if (entry[0] != "stateKey") {
                formValues[entry[0]] = entry[1];
            } else {
                let stateArr = entry[1].split("-");
                formValues[entry[0]] = stateArr[0];
                formValues.stateCode = stateArr[1];
            }
        }
        let errors = validateFields();
        setFormErrors(errors);
        if (!errors || errors.length === 0) {
            updateCompany();
        } else {
            setIsSubmit(false);
        }

    };
    const validateFields = () => {
        const errors = [];
        if (!formValues.companyName) {
            errors.push(t("error.companyNameReqd"));
        }
        if (!formValues.countryCode) {
            errors.push(t("error.countryReqd"));
        }
        if (!formValues.stateKey || formValues.stateKey === 0) {
            errors.push(t("error.stateReqd"));
        }
        if (!formValues.companyTypeKey || formValues.companyTypeKey === 0) {
            errors.push(t("error.companyTypeReqd"));
        }
        return errors;
    };
    const updateCompany = () => {
        let action = 2;
        if (add) {
            action = 1;
        }
        let serverParams = {
            companyId: company.companyId,
            companyName: formValues.companyName.trim(),
            companyTypeKey: formValues.companyTypeKey,
            companyGroup: formValues.companyGroup,
            address1: (formValues.address1) ? formValues.address1.trim() : '',
            address2: (formValues.address2) ? formValues.address2.trim() : '',
            phone: (formValues.phone) ? formValues.phone.trim() : '',
            zipCode: (formValues.zipCode) ? formValues.zipCode.trim() : '',
            zipExt: (formValues.zipExt) ? formValues.zipExt.trim() : '',
            city: (formValues.city) ? formValues.city.trim() : '',
            stateKey: formValues.stateKey,
            stateCode: (formValues.stateCode) ? formValues.stateCode.trim() : '',
            countryCode: formValues.countryCode,
            companyTimeZone: formValues.companyTimeZone,
            companyTypeAliasKey: formValues.companyTypeAliasKey,
            realCompanyName: (formValues.realCompanyName) ? formValues.realCompanyName.trim() : '',
            contactName: (formValues.contactName) ? formValues.contactName.trim() : '',
            contactEmail: (formValues.contactEmail) ? formValues.contactEmail.trim() : '',
            companyURL: (formValues.companyURL) ? formValues.companyURL.trim() : '',
            companyLanguage: formValues.companyLanguage,
            latitude: (formValues.latitude) ? formValues.latitude.trim() : '',
            longitude: (formValues.longitude) ? formValues.longitude.trim() : '',
            unitOfMeasure: formValues.unitOfMeasure,
            multiCompany: multiCompanyRef.current.checked,
            source: "web",
            action: action,
            updatedById: formValues.updatedById,
            canTakeCorrectiveAction: canTakeCorrectiveActionRef.current.checked,
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("UpdateCompany", "/Service/CompanyService/AddUpdateCompany", requestOptions, updateCompanySuccess, updateCompanyFail);
        } catch (error) {
            setError(error.message);
        }
    };

    function updateCompanyFail(redirect) {
        setIsSubmit(false);
        setError(t("error.companyEditFailed"));
    }
    function updateCompanySuccess(responseData) {
        setIsSubmit(false);
        let addUpdateCompanyResponse;
        if (responseData) {
            addUpdateCompanyResponse = responseData.addUpdateCompanyResponse;
            if (addUpdateCompanyResponse) {
                if (addUpdateCompanyResponse.errorCode === "0") {
                    setShow(false);
                    refetch();
                    navigate("/pages/companies");
                } else {
                    setError(t("error.error") + " " +
                        addUpdateCompanyResponse.errorMessage
                    );
                }
            }
        }
    }

    return (
        <div className="modalContainer hide-scrollbar">
            {userCtx.role === "SiteAdmin" ?
                <>
                    <div className="row">
                        <div className="col mt-3">
                            {((formErrors && formErrors.length > 0) || error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {((formErrors && formErrors.length > 0)) ? (
                                        formErrors.map((errorData, index) => (
                                            <p className="message-line">{errorData}</p>
                                        ))
                                    ) : (<></>)}
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <form
                                className="regn_form_container"
                                acceptCharset="UTF-8"
                                id="sign-up"
                                onSubmit={handleSubmit}
                            >
                                <h2>{(add) ? t("page.company.add") : t("page.company.edit")}
                                </h2>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.name")}
                                            </label>
                                            <input name="companyName" value={formValues.companyName} maxlength="75"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.company.type")}
                                            </label>
                                            <Select
                                                name="companyTypeKey"
                                                options={companyTypeOptions}
                                                onChange={companyTypeHandler}
                                                placeholder={""}
                                                value={companyTypeSelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="companyTypeKey-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.phone")}
                                            </label>
                                            <input name="phone" value={formValues.phone}
                                                maxlength="15" className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.country")}
                                            </label>
                                            <Select
                                                name="countryCode"
                                                options={countryOptions}
                                                onChange={countryHandler}
                                                placeholder={defCountryText}
                                                value={countrySelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="countryCode-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.address1")}
                                            </label>
                                            <input name="address1" value={formValues.address1} maxlength="40"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.address2")}
                                            </label>
                                            <input name="address2" value={formValues.address2} maxlength="40"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.city")}
                                            </label>
                                            <input name="city" value={formValues.city} maxlength="40"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.state")}
                                            </label>
                                            <Select
                                                name="stateKey"
                                                options={stateOptions}
                                                onChange={stateHandler}
                                                placeholder={""}
                                                value={stateSelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="stateKey-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.zipCode")}
                                            </label><input name="zipCode" value={formValues.zipCode}
                                                maxlength="12"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.zipExt")}
                                            </label>
                                            <input name="zipExt" value={formValues.zipExt}
                                                maxlength="4"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.latitude")}
                                            </label><input name="latitude" value={formValues.latitude}
                                                maxlength="13"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.longitude")}
                                            </label>
                                            <input name="longitude" value={formValues.longitude}
                                                maxlength="13"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.timezone")}
                                            </label>
                                            <Select
                                                name="companyTimeZone"
                                                options={timezoneOptions}
                                                onChange={timezoneHandler}
                                                placeholder={""}
                                                value={timezoneSelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="companyTimeZone-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.entity")}
                                            </label>
                                            <select name="companyGroup"
                                                className="form-select form-select-sm"
                                                style={{ borderRadius: "5px" }}
                                                onChange={(e) => valueHandler(e)}
                                                value={formValues.companyGroup}>
                                                <option />
                                                {companyGroups.map((companyGroup) => (
                                                    (companyGroup.groupName !== 'CONS') &&
                                                    <option value={companyGroup.groupName}>
                                                        {companyGroup.description}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.language")}
                                            </label>
                                            <select name="companyLanguage"
                                                className="form-select form-select-sm"
                                                style={{ borderRadius: "5px" }}
                                                onChange={(e) => valueHandler(e)}
                                                value={formValues.companyLanguage}>
                                                <option value="ar">
                                                    {t("page.arabic")}
                                                </option>
                                                <option value="en">
                                                    {t("page.english")}
                                                </option>
                                                <option value="fr">
                                                    {t("page.french")}
                                                </option>
                                                <option value="sr">
                                                    {t("page.serb.cyrl")}
                                                </option>
                                                <option value="es">
                                                    {t("page.spanish")}
                                                </option>

                                                <option value="tr">
                                                    {t("page.turkish")}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.uom")}
                                            </label>
                                            <Select
                                                name="unitOfMeasure"
                                                options={uomOptions}
                                                onChange={uomHandler}
                                                placeholder={""}
                                                value={uomSelected}
                                                isSearchable={true}
                                                isClearable={false}
                                                className="myselect"
                                                inputId="unitOfMeasure-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.contactName")}
                                            </label><input name="contactName" value={formValues.contactName}
                                                maxlength="50"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.contactEmail")}
                                            </label>
                                            <input name="contactEmail" value={formValues.contactEmail}
                                                maxlength="50"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.companyURL")}
                                            </label><input name="companyURL" value={formValues.companyURL}
                                                maxlength="50"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.multi.comp")}
                                            </label>
                                            <input type="checkbox" className="mycheckbox"
                                                ref={multiCompanyRef}
                                                name={"multiCompany"}
                                                id={"multiCompany"}
                                                defaultChecked={false}
                                                checked={multiCompany}
                                                onChange={(e) => multiCompanyHandler(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.canTakeCorrectiveAction")}
                                            </label>
                                            <input type="checkbox" className="mycheckbox"
                                                ref={canTakeCorrectiveActionRef}
                                                name={"canTakeCorrectiveAction"}
                                                id={"canTakeCorrectiveAction"}
                                                defaultChecked={true}
                                                checked={isCanTakeCorrectiveAction}
                                                onChange={onResponseChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <input
                                        type="button"
                                        name="edit-comp-close"
                                        id="edit-comp-close"
                                        className="btn btn-secondary btn-block" data-dismiss="modal"
                                        disabled={isSubmit}
                                        onClick={(e) => setShow(false)}
                                        style={{ marginRight: "50px" }}
                                        value={closeText}
                                    ></input>

                                    <div id="submit-spinner"
                                        className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                                    >  </div>
                                    <input
                                        type="submit"
                                        name="edit-submit"
                                        id="edit-submit"
                                        data-dismiss="modal"
                                        className={"btn btn-primary btn-block"}
                                        style={{ marginTop: "10px", marginBottom: "10px" }}
                                        value={submitText}
                                        disabled={isSubmit}
                                    >
                                    </input>

                                </div>
                            </form>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col mt-3">
                            {((formErrors && formErrors.length > 0) || error) ? (
                                <div id="berrorMessage" className="errorblock">
                                    {((formErrors && formErrors.length > 0)) ? (
                                        formErrors.map((errorData, index) => (
                                            <p className="message-line">{errorData}</p>
                                        ))
                                    ) : (<></>)}
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg" style={{ height: "110px" }}></div>
                        </div>
                    </div>
                </>
                : null}
        </div>
    );
}

export default CompanyModal;